'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ContextTypes = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /**
                    * @copyright 2015-present, Prometheus Research, LLC
                    */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _keyPath = require('./keyPath');

var _keyPath2 = _interopRequireDefault(_keyPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ContextTypes = exports.ContextTypes = {
  formValue: _propTypes2.default.object
};

var selectPropType = _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]);

/**
 * Base class for form components.
 *
 * It exposes form value via `this.formValue` which is provided either via
 * `this.props.formValue` or via context.
 */
var Component = (_temp = _class = function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    _classCallCheck(this, Component);

    return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
  }

  _createClass(Component, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { formValue: this.formValue };
    }
  }, {
    key: 'formValue',
    get: function get() {
      var formValue = this.props.formValue || this.context.formValue;

      (0, _invariant2.default)(formValue, 'A form component <%s /> should receive form value via props ' + 'or be used as a part of element hierarchy which ' + 'provides form value via context.', this.constructor.displayName || this.constructor.name);

      var select = this.props.select || this.props.selectFormValue;
      // We check for select !== true to keep compatability we eariler
      // versions of React Forms where we needed to rebuild element tree to
      // propagate values to form.
      if (select && select !== true) {
        select = (0, _keyPath2.default)(select);
        formValue = formValue.select(select);
      }

      return formValue;
    }
  }]);

  return Component;
}(_react2.default.Component), _class.propTypes = {
  /**
   * Form value passed as a prop.
   */
  formValue: _propTypes2.default.object,

  /**
   * Selector for form value.
   *
   * Used to select a part from a form value passed via context.
   */
  select: selectPropType,

  /**
   * Same as `select`.
   *
   * Deprecated.
   */
  selectFormValue: selectPropType
}, _class.contextTypes = ContextTypes, _class.childContextTypes = ContextTypes, _temp);
exports.default = Component;
